import { Pipe, PipeTransform } from '@angular/core';
import { FormatFileSizePipe, SpDateFormatPipe, TableColumnType } from '@thehubz/client/core';
import { AnyType } from '@thehubz/shared/model';

@Pipe({
  name: 'formatData',
})
export class FormatDataPipe implements PipeTransform {
  constructor(
    private readonly dateFormatPipe: SpDateFormatPipe,
    private readonly fileSizeFormatPipe: FormatFileSizePipe,
  ) {}

  transform(value: AnyType, type?: TableColumnType) {
    switch (type) {
      case TableColumnType.date:
        return this.dateFormatPipe.transform(value, { plainDate: true });
      case TableColumnType.dateTime:
        return this.dateFormatPipe.transform(value, { dateTimeShort: true, addPrefix: false });
      case TableColumnType.fileSize:
        return this.fileSizeFormatPipe.transform(value);
      default:
        return value;
    }
  }
}
